<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-textarea"></require>

  <div>
    <div class="form-row">
      <div class="col-md-12" if.bind="!model.archivedOn">
        <bs-form-input type="text" label="Approval Level Name" placeholder="Approval level name" value.bind="model.name & validate" maxlength="500"></bs-form-input>
      </div>
      <div class="col-md-6 sc-archived" if.bind="model.archivedOn">
        <bs-form-input type="text" label="Approval Level Name" placeholder="Approval level name" value.bind="model.name & validate" disabled.bind="true" maxlength="500"></bs-form-input>
      </div>
      <div class="col-md-6" if.bind="model.archivedOn">
        <bs-form-input type="text" label="Archived by ${model.archivedBy.fullName || model.archivedBy.loginName}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12 ${!model.isActive ? 'sc-archived' : ''}">
        <bs-form-textarea type="text" label="Approval Level Description" placeholder="Approval level description" value.bind="model.description & validate" maxlength="500" disabled.bind="!model.isActive"></bs-form-textarea>
      </div>
    </div>
  </div>
</template>
